import { Platform, StyleSheet, View } from 'react-native';

import { MqSwitch } from '@fhs/ui';

import { AppHeaderDesktop } from './app-header-desktop';
import { AppHeaderMobile } from './app-header-mobile';
import { AppHeaderProps } from './types';

export function AppHeader(props: AppHeaderProps) {
  return (
    <View
      style={styles.banner}
      {...(Platform.OS === 'web'
        ? {
            role: 'banner' as const,
            accessibilityLabel: 'Site header',
          }
        : {})}
    >
      <MqSwitch
        $ltDesktop={() => <AppHeaderMobile {...props} />}
        $gteDesktop={() => <AppHeaderDesktop {...props} />}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    width: '100%',
  },
});
